// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-title__container[data-v-473e9275]{border-left-width:thin;border-right-width:thin;border-left-color:rgba(0,0,0,.12);border-bottom:thin solid rgba(0,0,0,.12);border-right-color:rgba(0,0,0,.12);border-top:thin solid rgba(0,0,0,.12);background-color:#fafafa}", ""]);
// Exports
module.exports = exports;
